define("shared/components/shared/post/secondary/publishing-method-setup/setup/auto-publish/index", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@glimmer/component", "later/utils/constants"], function (_exports, _component, _templateFactory, _object, _service, _component2, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"later/utils/constants"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if @socialProfile.isTiktok}}
    {{! Tiktok Enable Auto Publish }}
    <Shared::Post::Secondary::PublishingMethodSetup::Setup::Card
      @buttonText={{t "onboarding.side_wiz.general.cards.enable_auto_publish"}}
      @content={{t "onboarding.side_wiz.general.cards.auto_publish_cont1"}}
      @header={{t "onboarding.side_wiz.general.cards.auto_publish"}}
      @onClick={{this.enableTiktokAutoPublish}}
      @recommended={{@recommended}}
      @svg={{svg-jar "instant" class="o--icon--md u--m__r__sm"}}
    />
  {{else if @socialProfile.isProfessional}}
    {{! IG Enable Auto Publish }}
    <Shared::Post::Secondary::PublishingMethodSetup::Setup::Card
      @buttonText={{t "onboarding.side_wiz.general.cards.auto_publish_setup"}}
      @content={{t "onboarding.side_wiz.general.cards.auto_publish_cont1"}}
      @header={{t "onboarding.side_wiz.general.cards.auto_publish"}}
      @onClick={{fn @setPublishingSetupComponent this.autoPublishComponent}}
      @recommended={{@recommended}}
      @svg={{svg-jar "instant" class="o--icon--md u--m__r__sm"}}
      class={{"qa--setup_autopub_btn"}}
      {{track "clicked-set-up-auto-publishing" "click"}}
    />
  {{else}}
    {{! Switch to Business Profile }}
    <Shared::Post::Secondary::PublishingMethodSetup::Setup::Card
      @buttonText={{t "onboarding.side_wiz.general.cards.auto_publish_setup2"}}
      @content={{html-safe
        (t "onboarding.side_wiz.general.cards.auto_publish_cont" username=@socialProfile.displayNickname)
      }}
      @header={{t "onboarding.side_wiz.general.cards.auto_publish"}}
      @onClick={{fn @setPublishingSetupComponent this.autoPublishComponent}}
      @recommended={{@recommended}}
      @svg={{svg-jar "instant" class="o--icon--md u--m__r__sm"}}
      class={{"qa--setup_autopublish_btn"}}
      {{track "clicked-convert-to-business-profile" "click"}}
    />
  {{/if}}
  */
  {
    "id": "v1huNOLt",
    "block": "[[[41,[30,1,[\"isTiktok\"]],[[[1,\"  \"],[8,[39,1],null,[[\"@buttonText\",\"@content\",\"@header\",\"@onClick\",\"@recommended\",\"@svg\"],[[28,[37,2],[\"onboarding.side_wiz.general.cards.enable_auto_publish\"],null],[28,[37,2],[\"onboarding.side_wiz.general.cards.auto_publish_cont1\"],null],[28,[37,2],[\"onboarding.side_wiz.general.cards.auto_publish\"],null],[30,0,[\"enableTiktokAutoPublish\"]],[30,2],[28,[37,3],[\"instant\"],[[\"class\"],[\"o--icon--md u--m__r__sm\"]]]]],null],[1,\"\\n\"]],[]],[[[41,[30,1,[\"isProfessional\"]],[[[1,\"  \"],[8,[39,1],[[24,0,\"qa--setup_autopub_btn\"],[4,[38,5],[\"clicked-set-up-auto-publishing\",\"click\"],null]],[[\"@buttonText\",\"@content\",\"@header\",\"@onClick\",\"@recommended\",\"@svg\"],[[28,[37,2],[\"onboarding.side_wiz.general.cards.auto_publish_setup\"],null],[28,[37,2],[\"onboarding.side_wiz.general.cards.auto_publish_cont1\"],null],[28,[37,2],[\"onboarding.side_wiz.general.cards.auto_publish\"],null],[28,[37,4],[[30,3],[30,0,[\"autoPublishComponent\"]]],null],[30,2],[28,[37,3],[\"instant\"],[[\"class\"],[\"o--icon--md u--m__r__sm\"]]]]],null],[1,\"\\n\"]],[]],[[[1,\"  \"],[8,[39,1],[[24,0,\"qa--setup_autopublish_btn\"],[4,[38,5],[\"clicked-convert-to-business-profile\",\"click\"],null]],[[\"@buttonText\",\"@content\",\"@header\",\"@onClick\",\"@recommended\",\"@svg\"],[[28,[37,2],[\"onboarding.side_wiz.general.cards.auto_publish_setup2\"],null],[28,[37,6],[[28,[37,2],[\"onboarding.side_wiz.general.cards.auto_publish_cont\"],[[\"username\"],[[30,1,[\"displayNickname\"]]]]]],null],[28,[37,2],[\"onboarding.side_wiz.general.cards.auto_publish\"],null],[28,[37,4],[[30,3],[30,0,[\"autoPublishComponent\"]]],null],[30,2],[28,[37,3],[\"instant\"],[[\"class\"],[\"o--icon--md u--m__r__sm\"]]]]],null],[1,\"\\n\"]],[]]]],[]]]],[\"@socialProfile\",\"@recommended\",\"@setPublishingSetupComponent\"],false,[\"if\",\"shared/post/secondary/publishing-method-setup/setup/card\",\"t\",\"svg-jar\",\"fn\",\"track\",\"html-safe\"]]",
    "moduleName": "shared/components/shared/post/secondary/publishing-method-setup/setup/auto-publish/index.hbs",
    "isStrictMode": false
  });

  let AutoPublishComponent = (_class = class AutoPublishComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "tiktok", _descriptor2, this);
    }

    get autoPublishComponent() {
      return _constants.NO_PUBLISHING_METHOD_COMPONENTS.AUTO_PUBLISH_SETUP;
    }

    get isMultiProfilePost() {
      return this.args.isMultiProfilePost;
    }

    get redirectPath() {
      const firstMediaItem = this.args.post.get('firstMediaItem');

      const mediaItemId = firstMediaItem?.get('id') ?? _constants.TEXT_POST_TYPE;

      const scheduledTime = this.args.post.get('scheduledTime');
      const id = this.args.post.get('id') ?? mediaItemId;
      const postType = this.isMultiProfilePost ? 'multi/new' : 'new';
      const path = `${this.auth.currentGroup.slug}/schedule/calendar/post/${id}/${postType}?scheduledTime=${scheduledTime}`;
      return path;
    }

    enableTiktokAutoPublish() {
      this.tiktok.refresh(this.auth.currentSocialProfile, this.redirectPath);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "tiktok", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "enableTiktokAutoPublish", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "enableTiktokAutoPublish"), _class.prototype)), _class);
  _exports.default = AutoPublishComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, AutoPublishComponent);
});